import {Link, useNavigate, useParams} from "react-router-dom";
import DarkCard from "../../../../../../../components/card/DarkCard";
import React, {useEffect, useReducer} from "react";
import {TxtTitles} from "../../../../../../../helpers/breadCrumbs";
import {useTranslation} from "react-i18next";
import LightCard from "../../../../../../../components/card/LightCard";
import StaffInfo from "../StaffInfo";
import {isObjectEmpty} from "../../../../../../../helpers/tools";
import Error404 from "../../../../../../Error404";
import {RedirectButton} from "../../../../../../../helpers/Redirect";
import FeedsList from "../FeedsList";
import Events from "../Events";
import TechnicalInfo from "./techInfo/TechnicalInfo";
import LineupInfo from "./LineUpInfo";
import {projectsCurrentDetailsAPI} from "../../../../../../../services/api/projectCurrent";
import MenuButtons from "./MenuButtons";


const INITIAL_DOC = {
    dataset: {},
    popup: {show: false},
}

const projectReducer = (prev, action) => {
    switch (action.type) {
        case "PROJECT_DATA_INITIAL":
            return {...prev, dataset: action.projectData}

        default:
            return prev;
    }
    throw Error('Unknown action: ' + action);
}


export default function ProjectCurrentItem() {
    const [state, dispatch] = useReducer(projectReducer, INITIAL_DOC, undefined)
    const params = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        const get_DataAPI = async () => {
            const response = await projectsCurrentDetailsAPI(params.id)
            if (response.status === 200) {
                dispatch({type: "PROJECT_DATA_INITIAL", projectData: response.data})
            } else return <Error404/>
        }
        get_DataAPI()

    }, [params.id])

    const redirectHandler = (opt) => {
        const datasetName = state.dataset.name;
        sessionStorage.setItem('project-current-return', '/projects/current/'+params.id)
        if (opt === "staff") {
            navigate("/projects/current/staff-edit/"+params.id, { state: { datasetName } })
        }
        if (opt === "events") {
            navigate("/projects/current/events-edit/"+params.id, { state: { datasetName } })
        }
        if (opt === "techInfo") {
            navigate("/projects/current/tech-info-edit/"+params.id, { state: { datasetName } })
        }
        if (opt === "lineup") {
            navigate("/projects/current/lineup-edit/"+params.id, { state: { datasetName } })
        }
    }

    if (isObjectEmpty(state.dataset)) return null

    return (<>
        <DarkCard classNames='mb-3 row'>
            <p className="m-0 p-0 breadcrumbs">
                <span className="txt">{t("menu.projects",{ ns: 'menu' })}</span>&#8201;&#9656;&#8201;
                <Link to={'/projects/currents-list'} className="edit-link">{t("menu.current_projects",{ ns: 'menu' })}</Link>&#8201;&#9656;&#8201;
                <Link to={'/projects/current/'+params.id} className="edit-link">{t("breadcrumbs.project_title")} P{params.id}</Link>
            </p>
        </DarkCard>

        <DarkCard classNames='mb-3 row'>
            <TxtTitles>{t("project.project_name_title")}</TxtTitles>
            <h1 className='mb-0 mt-0 p-0' style={{marginTop: '-5px'}}>
                {state.dataset.name}
            </h1>
            <p className="mt-3 ps-0" style={{fontSize:'14px'}}>
                {t("project.project_id_title")} P{params.id}
            </p>

            <MenuButtons projectId={params.id} active={{table: "active"}} />

            <div className='mb-3 mt-5 px-0'>
                {/*STAFF*/}
                <RedirectButton redirect_to_path={() => redirectHandler("staff")}>
                    {t("common.button.edit_staff")}
                </RedirectButton>
                <LightCard>
                    <StaffInfo
                        staff={state.dataset.staff}
                        conductor={state.dataset.calculation.conductor}
                        others={state.dataset.calculation.others}
                    />
                    <div>{t("project.kzm_status")} {state.dataset.kzmProject ? t("Yes") : t("No")}</div>
                </LightCard>
            </div>

            {/*EVENTS*/}
            <div className='mb-3 px-0'>
                <div className="mt-5 mb-2" style={{overflow: 'hidden'}}>
                    <RedirectButton redirect_to_path={() => redirectHandler("events")}>
                        {t("common.button.edit_events")}
                    </RedirectButton>
                </div>
                <LightCard>
                    <Events
                        eventDetails={state.dataset.eventDetails}
                        estimationID={""}
                        events={state.dataset.current_events}
                    />
                </LightCard>
            </div>

            {/*TECHNICAL INFORMATIONS*/}
            <div className='mb-3 px-0'>
                <div className="mt-5 mb-2" style={{overflow: 'hidden'}}>
                    <RedirectButton redirect_to_path={() => redirectHandler("techInfo")}>
                        {t("common.button.edit_techInfo")}
                    </RedirectButton>
                </div>
                <LightCard>
                    <TechnicalInfo dataSet={state.dataset.techInfo} />
                </LightCard>
            </div>

            {/*MUSICIANS LINEUP*/}
            <div className='mb-3 px-0'>
                <div className="mt-5 mb-2" style={{overflow: 'hidden'}}>
                    <RedirectButton redirect_to_path={() => redirectHandler("lineup")}>
                        {t("common.button.edit_lineup")}
                    </RedirectButton>
                </div>
                <LightCard>
                    <LineupInfo 
                        staff={state.dataset.staff}
                        others={state.dataset.calculation.others}
                    />
                </LightCard>
            </div>
        </DarkCard>

        <DarkCard classNames='mb-3 row'>
            {/*FEED*/}
            <FeedsList projectID={state.dataset.project}/>
        </DarkCard>
    </>
)
}